// extracted by mini-css-extract-plugin
export default {"Snackbar":"Snackbar_Snackbar__tasxj","message":"Snackbar_message__chgi+","user":"Snackbar_user__8-NEx","text":"Snackbar_text__Rtb01"};